export default __webpack_public_path__ + "static/wallpaper-8-pc-6bb3d5e4bf6ef5cc03bd965b8a44a2ab.png";